import { render } from "./Contact.vue?vue&type=template&id=271dbab3"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/lockstep/Contact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "271dbab3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('271dbab3', __exports__)) {
    api.reload('271dbab3', __exports__)
  }
  
  module.hot.accept("./Contact.vue?vue&type=template&id=271dbab3", () => {
    api.rerender('271dbab3', render)
  })

}


export default __exports__